import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { useSignatureCount } from './useSignatures';
import styles from '../layoff.module.scss';

/**
 * Left nav entry for Superintendents. Only shown while they have lay-off notices to sign
 * (or while they are on those pages).
 */
const SignaturesNavItem = ({ location, onClick }) => {
  const { data: count = 0 } = useSignatureCount();
  const onPage = location.pathname.startsWith('/layoff/sign');

  if (!count && !onPage) {
    return null;
  }

  return (
    <li>
      <NavLink
        to='/layoff/sign'
        activeClassName='active'
        isActive={() => onPage}
        onClick={onClick}
      >
        Lay-off signatures
        {count > 0 && (
          <span
            className={styles.nav_badge}
            aria-label={`${count} waiting for your signature`}
          >
            {count}
          </span>
        )}
      </NavLink>
    </li>
  );
};

export default withRouter(SignaturesNavItem);
